import styled from "styled-components/macro";
import AuEmage from "./auEmage";
import media from "../../constants/MediaQuery";
import Typography from "../../atoms/typography";

const OurMission = () => {
  return (
    <OMStyling>
      <div className="OurMission__OMStyling__OM-container container">
        <div className="OurMission__OMStyling__OM-container--au">
          <Typography.Heading
            className="landing--text-summary"
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            Our mission
          </Typography.Heading>
          <Typography.Heading
            className="landing__heading"
            color="darkBlue"
            fontType="Galano"
            weight="medium"
            level={1}
          >
            Who we are
          </Typography.Heading>
          <Typography.Text
            level="xlarge"
            color="black"
            weight="medium"
            fontType="Galano"
          >
            We are people from diverse backgrounds banded together to help
            millions of underbanked Nigerians to access secure and convenient
            banking services by bringing the bank to all local communities.
          </Typography.Text>
        </div>
        <AuEmage />
      </div>
    </OMStyling>
  );
};
const OMStyling = styled.div`
  width: 100%;
  .OurMission__OMStyling {
    display: flex;
    &__OM-container {
      padding: 100px 0;
      display: flex;
      flex-direction: column;
      @media screen and (min-width: 700px) {
        flex-direction: row;
        justify-content: space-between;
      }
      &--au {
        padding: 40px 0;
        ${media.tabletMin` max-width: 440px;`}
      }
    }
  }
`;
export default OurMission;
